import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NgTemplateOutlet } from '@angular/common';
import { Ag1BadgeSolidComponent } from '../ag1-badge-solid/ag1-badge-solid.component';

@Component({
  selector: 'ag1-title',
  templateUrl: './ag1-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, Ag1BadgeSolidComponent],
})
export class Ag1TitleComponent implements OnInit, OnDestroy {
  private titleService = inject(Title);

  @Input()
  label = 'Title';

  @Input()
  state: 'new' | 'beta' | 'alpha' | undefined = undefined;

  agrigateOne: string = 'AgrigateOne';

  constructor() {}

  ngOnInit(): void {
    if (this.label === 'Title' || !this.label) {
      this.titleService.setTitle(this.agrigateOne);
      return;
    }

    this.titleService.setTitle(`${this.agrigateOne} | ${this.label}`);
  }

  ngOnDestroy(): void {
    this.titleService.setTitle(this.agrigateOne);
  }
}
